import {
	Box,
	Pagination,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow
} from '@mui/material';
import { useEffect } from 'react';
import SubmissionItem from './SubmissionItem';
import { useNavigate, useParams } from 'react-router-dom';
import useAcademyEventSubmission from 'hooks/useAcademyEventSubmission';

const TABLE_HEADERS = [
	{
		value: 'first_name',
		label: 'First Name',
		sortable: false,
		hidden: false
	},

	{
		value: 'last_name',
		label: 'Last Name',
		sortable: false,
		hidden: false
	},
	{
		value: 'event_name',
		label: 'Event Name',
		sortable: false,
		hidden: false
	}
];

const CompletedSubmissions = ({ tabValue }) => {
	const navigate = useNavigate();
	const { id } = useParams();
	const {
		findManyEventSubmissions,
		eventSubmissionResources,
		isLoading,
		isEmpty,
		paginate,
		query,
		page,
		numPages
	} = useAcademyEventSubmission({
		url: `/api/v1/admin/academies/${id}/academy_event_submissions`
	});

	const handleClick = (submission) => {
		navigate(
			`/academy/event_submissions/${submission.id}/submission?page=${page}&status=changes_requested&academy_id=${id}`
		);
	};

	useEffect(() => {
		if (tabValue === 1) {
			findManyEventSubmissions({
				status: 'changes_requested',
				page: page
			});
		}
	}, []);
	return (
		<div>
			{isEmpty && <Box my={2}>No new submissions available.</Box>}
			{!isEmpty && (
				<TableContainer>
					<Table>
						<TableHead>
							<TableRow>
								{TABLE_HEADERS.map(
									(header) =>
										!header.hidden && (
											<TableCell
												sx={{ fontWeight: 'bold', color: 'primary.main' }}
												key={header.value}
											>
												{header.label}
											</TableCell>
										)
								)}
							</TableRow>
						</TableHead>
						<TableBody>
							{eventSubmissionResources.map((submission) => (
								<SubmissionItem
									key={submission.id}
									submission={submission}
									handleClick={handleClick}
								/>
							))}
						</TableBody>
					</Table>
				</TableContainer>
			)}
			{!isEmpty && (
				<Box my={1}>
					<Pagination
						onChange={(ev, page) => paginate(page)}
						color="primary"
						size="small"
						shape="rounded"
						page={page}
						count={numPages}
					/>
				</Box>
			)}
		</div>
	);
};

export default CompletedSubmissions;
